import { SelectBox, TextBox, Validator } from "devextreme-react";
import { useDispatch } from "react-redux";
import { updateName, updatePos } from "./Redux/sponsorInfo";
import { useEffect, useState } from "react";
import axios from "axios";
import DataSource from "devextreme/data/data_source";
import { Width } from "devextreme-react/chart";
import { RequiredRule } from "devextreme-react/form";

export default function ContactPersonComponent(props) {
  const { sponsorInfo } = props;

  const dispatch = useDispatch();

  const [posDataSource, setPosDataSource] = useState(null);

  useEffect(async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/sprInfo/pos`
    );

    setPosDataSource(
      new DataSource({
        store: {
          data: result.data,
          type: "array",
          key: "pos",
        },
      })
    );
  }, []);

  const onNameValueChanged = (e) => {
    dispatch(
      updateName({
        name: e.value,
      })
    );
  };

  const onPosValueChanged = (e) => {
    dispatch(
      updatePos({
        pos: e.value,
      })
    );
  };

  const onCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;

      return;
    }

    const newItem = {
      pos: args.text,
    };

    args.customItem = posDataSource
      .store()
      .insert(newItem)
      .then(() => posDataSource.load())
      .then(() => newItem)
      .catch((error) => {
        throw error;
      });
  };

  return (
    <>
      <TextBox
        value={sponsorInfo.name}
        showClearButton={true}
        style={{
          float: "left",
          width: "45%",
          marginRight: "3px",
        }}
        placeholder="Name"
        onValueChanged={onNameValueChanged}
      >
        <Validator validationGroup="sponsorInfoData">
          <RequiredRule message={"Name is required."} />
        </Validator>
      </TextBox>
      <SelectBox
        dataSource={posDataSource}
        value={sponsorInfo.pos}
        displayExpr={"pos"}
        valueExpr={"pos"}
        showClearButton={true}
        acceptCustomValue={true}
        style={{
          float: "left",
          width: "45%",
        }}
        placeholder="Position"
        onValueChanged={onPosValueChanged}
        onCustomItemCreating={onCustomItemCreating}
      >
        <Validator validationGroup="sponsorInfoData">
          <RequiredRule message={"Position is required."} />
        </Validator>
      </SelectBox>
    </>
  );
}
